import React from 'react';
import { SERVICE_PACKAGES, BRAND_COLOR, INSTAGRAM_URL } from '../constants';

const Pricing: React.FC<{ isDarkMode: boolean }> = ({ isDarkMode }) => (
  <section id="services" className={`py-32 border-t transition-colors duration-500 ${isDarkMode ? 'bg-black border-white/5' : 'bg-white border-zinc-100'}`}>
    <div className="max-w-[1400px] mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {SERVICE_PACKAGES.map(pkg => (
        <div 
          key={pkg.id} 
          className={`relative p-8 md:p-10 border transition-all duration-500 flex flex-col h-full shadow-sm
            ${pkg.isFeatured 
              ? 'bg-[#0a0a0a] border-brand scale-105 z-10 shadow-[0_0_40px_rgba(255,77,0,0.15)] ring-1 ring-brand/30' 
              : isDarkMode ? 'bg-black border-white/10' : 'bg-zinc-50 border-zinc-200'}`}
        >
          <div className="mb-8">
            <span className={`text-[12px] font-bold tracking-[0.4em] mb-4 block uppercase ${pkg.isFeatured ? 'text-zinc-500' : isDarkMode ? 'text-zinc-500' : 'text-zinc-400'}`}>
              # {pkg.number}
            </span>
            <h3 className={`text-4xl font-display font-black uppercase mb-4 tracking-tight ${pkg.isFeatured ? 'text-white' : isDarkMode ? 'text-white' : 'text-black'}`}>
              {pkg.title}
            </h3>
            <div className="flex items-baseline gap-2">
              <p style={{ color: BRAND_COLOR }} className="text-5xl font-black italic tracking-tighter">
                {pkg.price}
              </p>
            </div>
          </div>

          <div className="flex-grow space-y-5 mb-12">
            {pkg.features.map((f, idx) => {
              const isHighlighted = f === pkg.highlightedFeature;
              
              return (
                <div key={f} className="flex items-start gap-3">
                  <div className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: isHighlighted ? BRAND_COLOR : (pkg.isFeatured ? '#3f3f46' : (isDarkMode ? '#3f3f46' : '#d4d4d8')) }}></div>
                  <p 
                    className={`text-[13px] font-bold tracking-[0.05em] uppercase leading-relaxed
                      ${isHighlighted ? 'text-brand' : (pkg.isFeatured || isDarkMode) ? 'text-white' : 'text-zinc-600'}`}
                  >
                    {f}
                  </p>
                </div>
              );
            })}
          </div>

          <a 
            href={INSTAGRAM_URL} 
            target="_blank" 
            style={{ 
              backgroundColor: pkg.isFeatured ? BRAND_COLOR : 'white', 
              color: 'black' 
            }} 
            className="w-full py-5 text-center font-black text-[13px] uppercase tracking-[0.2em] hover:brightness-110 active:scale-[0.98] transition-all shadow-lg"
          >
            SECURE SESSION
          </a>
        </div>
      ))}
    </div>
  </section>
);

export default Pricing;